// Branding Configuration
export const GET_BRANDING_CONFIG_REQUEST = 'GET_BRANDING_CONFIG_REQUEST';
export const GET_BRANDING_CONFIG_SUCCESS = 'GET_BRANDING_CONFIG_SUCCESS';
export const GET_BRANDING_CONFIG_ERROR = 'GET_BRANDING_CONFIG_ERROR';

export const UPDATE_BRANDING_CONFIG_REQUEST = 'UPDATE_BRANDING_CONFIG_REQUEST';
export const UPDATE_BRANDING_CONFIG_SUCCESS = 'UPDATE_BRANDING_CONFIG_SUCCESS';
export const UPDATE_BRANDING_CONFIG_ERROR = 'UPDATE_BRANDING_CONFIG_ERROR';

export const UPLOAD_BRANDING_LOGO_REQUEST = 'UPLOAD_BRANDING_LOGO_REQUEST';
export const UPLOAD_BRANDING_LOGO_SUCCESS = 'UPLOAD_BRANDING_LOGO_SUCCESS';
export const UPLOAD_BRANDING_LOGO_ERROR = 'UPLOAD_BRANDING_LOGO_ERROR';
